<template>
  <v-container
    id="seccionPreguntas"
    ref="sectionRoot"
    class="faq-container py-9"
    :class="{ 'is-visible': visible }"
    fluid
  >
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
        <v-row class="header-row text-center fade-slide-down">
          <v-col cols="12" md="10" lg="8" class="mx-auto">
            <div class="section-badge mb-3">
              <span class="section-badge__dot"></span>
              Preguntas frecuentes
            </div>

            <h2 class="header-title">
              Preguntas que otros también se han hecho
            </h2>
          </v-col>
        </v-row>

        <v-expansion-panels multiple flat class="faq-panels fade-slide-down">
          <v-expansion-panel
            v-for="(faq, index) in faqs"
            :key="index"
            class="faq-panel"
          >
            <v-expansion-panel-header class="faq-panel-header">
              <template #default="{ open }">
                <div class="faq-header-content">
                  <v-icon class="faq-icon" :class="{ 'faq-icon--active': open }">
                    mdi-help-circle
                  </v-icon>
                  <span class="faq-question">{{ faq.pregunta }}</span>
                </div>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="faq-panel-content">
              {{ faq.respuesta }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FaqSection',
  data() {
    return {
      visible: false,
      faqs: [
        {
          pregunta: '¿Si tengo una urgencia, qué cubre Medicover?',
          respuesta: 'Medicover cubre accidentes o emergencias medicas en las cuales su estancia hospitalaria no sea mayor a 24horas',
        },
        {
          pregunta: '¿Qué me cubre Medicover en mi cobertura dental?',
          respuesta: 'Al acudir con odontólogos de la red, tu consulta, valoración y profilaxis no tienen costo. El especialista realizará la valoración y solicitará la autorización correspondiente según el tratamiento que necesites. Solo espera la confirmación de Medicover para comenzar tu tratamiento.(Consulta los procedimientos cubiertos directamente con tu agente.)',
        },
        {
          pregunta: '¿Qué me cubre Medicover en mi cobertura visual?',
          respuesta: 'Te apoyamos con un monto para la compra de tus lentes de graduación. Consulta el monto vigente en tu contrato o con tu agente. Aplica copago.',
        },
        {
          pregunta: '¿Que no cubre Medicover en mi cobertura de urgencias médicas?',
          respuesta: 'Antes que nada, te compartimos cómo saber cuándo acudir por una emergencia médica: Toda alteración súbita de un órgano o función que ponga en peligro la vida, la integridad corporal o la viabilidad de alguno de los órganos, y que requiera atención médico-quirúrgica.Por lo tanto, no se cubrirán consultas médicas donde no haya habido un procedimiento quirúrgico ni se haya suministrado tratamiento médico. En cuanto a los estudios radiológicos, quedan excluidas las tomografías y resonancias. También te recomendamos leer los términos y condiciones en tu contrato.'
        },
        {
          pregunta: '¿Qué puedo hacer si no hay doctores disponibles en la especialidad que necesito?',
          respuesta: 'Si en ese momento no hay médicos disponibles en la especialidad que necesitas y esa especialidad se encuentra dentro de las especialidades Medicover, se gestionará un reembolso. Consulta con tu agente para conocer el proceso y los requisitos.',
        },
        {
          pregunta: '¿En caso de acudir a urgencias, qué tipo de médico debe atenderme para que esté cubierta por Medicover?',
          respuesta: 'Todos los medicos de guardia o staf propios del hospital pueden atenderte.',
        },
        {
          pregunta: '¿Dónde puedo obtener mis pases médicos?',
          respuesta: 'En tu perfil de Medicover, disponible en https://mi.medicover.mx/user/micuenta, puedes consultar tus pases médicos, generar nuevos, revisar tu estatus, acceder a tus facturas y mucho más.',
        },
        {
          pregunta: '¿Dónde puedo descargar mis facturas?',
          respuesta: 'A través de tu perfil https://mi.medicover.mx/user/micuenta, tendrás la opción de descargar tus facturas en formato PDF y XML. Para completar la solicitud de facturación , por favor envía tu constancia fiscal, correo electrónico y número de teléfono.',
        }
      ],
    };
  },
  mounted() {
    const el = this.$refs.sectionRoot?.$el || this.$refs.sectionRoot;
    if (!el || typeof IntersectionObserver === 'undefined') {
      this.visible = true;
      return;
    }

    this._observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible = true;
          this._observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    this._observer.observe(el);
  },
  beforeDestroy() {
    this._observer?.disconnect();
  }
};
</script>

<style scoped>
.faq-container {
  background: linear-gradient(180deg, #ffffff 0%, #f5f9fd 100%);
  border-radius: 24px;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px 7px 12px;
  border-radius: 999px;
  background: #dceeff;
  color: #1b4f8c;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.section-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1b4f8c;
}

.header-title {
  font-size: clamp(1.6rem, 2.8vw, 2.2rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: #16233a;
  margin-bottom: 8px;
}

.fade-slide-down {
  opacity: 0;
  transform: translateY(-24px);
}

.is-visible .fade-slide-down {
  animation: fadeSlideDown 0.8s ease forwards;
}

@keyframes fadeSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.faq-panels {
  margin-top: 32px;
  background: transparent !important;
}

/* Cada pregunta es su propia tarjeta, con espacio entre ellas,
   en vez de un bloque único - patrón de acordeón más actual */
.faq-panel {
  border-radius: 16px !important;
  margin-bottom: 12px;
  background: #ffffff !important;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden;
  transition: box-shadow 0.24s ease;
}

.faq-panel::before {
  box-shadow: none !important;
}

.faq-panel:hover {
  box-shadow: 0 8px 22px rgba(27, 79, 140, 0.1) !important;
}

.faq-panel-header {
  padding: 18px 22px !important;
  text-align: left;
}

.faq-header-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.faq-icon {
  color: #1b4f8c !important;
  flex-shrink: 0;
  margin-top: 1px;
  transition: color 0.2s ease;
}

.faq-question {
  font-weight: 600;
  font-size: 16px;
  color: #16233a;
  text-align: left;
  line-height: 1.5;
}

.faq-panel-content {
  text-align: left;
}

.faq-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0 22px 20px 54px;
  font-size: 15px;
  line-height: 1.7;
  color: #4b5563;
}

@media (prefers-reduced-motion: reduce) {
  .fade-slide-down {
    opacity: 1;
    transform: none;
    animation: none;
  }
}

@media (max-width: 600px) {
  .faq-container {
    border-radius: 18px;
  }

  .faq-panel-header {
    padding: 16px !important;
  }

  .faq-panel-content ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 16px 18px 44px;
  }
}
</style>